// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"116":"367ccb96","238":"9bc45589","514":"131c3512","631":"7b60f2df","878":"246d08b9","940":"35d35a01","991":"367ccb96"}[chunkId] + ".chunk.css";
};